//INDIVISUAL PERMISSION
export const PERMISSION_FETCH_START = "PERMISSION_FETCH_START";
export const PERMISSION_FETCH_SUCCESS = "PERMISSION_FETCH_SUCCESS";
export const PERMISSION_FETCH_FAILURE = "PERMISSION_FETCH_FAILURE";

//ALL PERMISSION
export const ALL_PERMISSION_FETCH_START = "ALL_PERMISSION_FETCH_START";
export const ALL_PERMISSION_FETCH_SUCCESS = "ALL_PERMISSION_FETCH_SUCCESS";
export const ALL_PERMISSION_FETCH_FAILURE = "ALL_PERMISSION_FETCH_FAILURE";

//POST PERMISSION
export const PERMISSION_POST_START = "PERMISSION_POST_START";
export const PERMISSION_POST_SUCCESS = "PERMISSION_POST_SUCCESS";
export const PERMISSION_POST_FAILURE = "PERMISSION_POST_FAILURE";
